import { Button, Card, CardContent, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Snackbar } from '@material-ui/core';
import AddIcCallIcon from '@material-ui/icons/AddIcCall';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import Alert from 'src/components/Alert';
import { getUser } from 'src/utils/Common';


const useStyles = makeStyles((theme) => ({
  root: {},
  submitButton: {
    marginTop: theme.spacing(2),
    width: '100%'
  }
}));


function IletisimDetay({ className }) {
  const classes = useStyles();
  const SessionUser = getUser();
  const [responseMessage, setresponseMessage] = useState({ ErrorCode: "0", ErrorDescription: "İşleminiz başarı ile gerçekleştirildi." });
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState();
  const [LoadingControl, setLoadingControl] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [Uyari1, setUyari1] = React.useState("");
  const handleClose = () => {
    setOpen(false);
  };

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const handleFgsAramaYap = (Telefon) => {
    var Uyari = "Merhaba " + SessionUser.FirstName + ", seni hemen servis merkezine ait " + Telefon + " no'lu telefon numarasına bağlayacağım. Aramayı başlatmamı ister misin? ";
    confirmAlert({
      message: Uyari,
      buttons: [
        {
          label: 'Evet',
          onClick: () => handleFgsAramaYapEvet(Telefon)
        },
        {
          label: 'Hayır',
          onClick: () => { return; }
        }
      ]
    });
  }


  const handleFgsAramaYapEvet = (Telefon) => {
    var UyariAlert = "Servis Merkezinin " + Telefon + " numaralı telefonu için arama başlatıldı.";
    setLoadingControl(true);
    var phoneNumber = "08507591180,0" + Telefon;
    if (SessionUser.MobileNumber === "4440888") {
      setresponseMessage({ ErrorCode: "10", ErrorDescription: "Arama yapabilmeniz için önce telefon numaranızı giriş ekranından kaydediniz!..." });
      setUyariTip("error");
      setUyari(true);
      setLoadingControl(false);
      return;
    }


    setresponseMessage({ ErrorCode: "0", ErrorDescription: "Arama Başarılı!..." });
    setUyariTip("success");
    setUyari(true);
    setLoadingControl(false);
    
    window.open(`tel:${phoneNumber}`, '_self');

    setUyari1(UyariAlert);
    setOpen(true);


  }
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">{"Bilgilendirme"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari1}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>
      <Card className={clsx(classes.root, className)}>
        <CardContent className={classes.content}>
          {
            LoadingControl ?
              <CircularProgress
                status={'loading'}
                style={{ marginLeft: '50%' }}
              />
              : <div></div>
          }
          <Button
            variant="contained"
            color="secondary"
            className={classes.submitButton}
            onClick={() => handleFgsAramaYap(SessionUser.ServiceShopTel1)}
            endIcon={<AddIcCallIcon>Call</AddIcCallIcon>}>
            Servis Merkezi : ({SessionUser.ServiceShopTel1.substring(0, 3)}){SessionUser.ServiceShopTel1.substring(3, 10)}
          </Button>
          <br />
          <br />
          <Button
            variant="contained"
            color="secondary"
            className={classes.submitButton}
            onClick={() => handleFgsAramaYap("8502100888")}
            endIcon={<AddIcCallIcon>Call</AddIcCallIcon>}>
            Çağrı Merkezi : 0850 210 0 888
          </Button>
          <br />
          <br />
          <Button
            variant="contained"
            color="secondary"
            className={classes.submitButton}
            onClick={() => handleFgsAramaYap("8502500767")}
            endIcon={<AddIcCallIcon>Call</AddIcCallIcon>}>
            Token Okc : 0850 250 0767
          </Button>
          <br />
          <br />
          <Button
            variant="contained"
            color="secondary"
            className={classes.submitButton}
            onClick={() => handleFgsAramaYap("8507594444")}
            endIcon={<AddIcCallIcon>Call</AddIcCallIcon>}>
            MEB KurumsalDestek : 0850 759 4444
          </Button>
          <br />
          <br />
          <Button
            variant="contained"
            color="secondary"
            className={classes.submitButton}
            onClick={() => handleFgsAramaYap("5521750000")}
            endIcon={<AddIcCallIcon>Call</AddIcCallIcon>}>
            Kapıdan Satışlar : 0552 175 0000
          </Button>
          <Snackbar open={uyari} onClose={uyariKapat} autoHideDuration={5000}>
            <Alert onClose={uyariKapat} message={responseMessage.ErrorDescription} variant={uyariTip} />
          </Snackbar>
        </CardContent>
      </Card>
    </div>
  );
}

IletisimDetay.propTypes = {
  className: PropTypes.string
};

export default IletisimDetay;
